// extracted by mini-css-extract-plugin
export var brand = "_a6-9";
export var compact = "_a6-6";
export var extraSmall = "_a6-7";
export var icon = "_a6-0";
export var large = "_a6-4";
export var light = "_a6-1";
export var medium = "_a6-5";
export var outline = "_a6-b";
export var primaryDark = "_a6-a";
export var primaryLight = "_a6-8";
export var primaryModern = "_a6-c";
export var success = "_a6-2";
export var successSolid = "_a6-3";